export default __webpack_public_path__ + "static/media/Elipsis.eabe4a2e.svg";